import { Sprite, Texture } from 'pixi.js';
import { SIZE } from '../../../../settings/constants';

export default class Cloud extends Sprite {
  posY: number;
  speed = 0;
  xLimit: number;

  constructor(textureName: string, posY: number) {
    super(Texture.from(textureName));

    //vars
    this.posY = posY;
    this.xLimit = this.width + SIZE.W * 0.5;

    // props
    this.anchor.set(0.5);

    // init position
    this.x = -SIZE.W * 0.5 + Math.random() * SIZE.W;
    this.resetCloud();
  }

  // --------------------------------------------------------------
  // Move
  // --------------------------------------------------------------

  resetCloud(): void {
    this.speed = 0.15 + Math.random() * 0.2;
    this.y = this.posY - 15 + Math.random() * 30;
    this.alpha = 0.8 + Math.random() * 0.2;
    this.scale.x = Math.random() > 0.5 ? 1 : -1;
  }

  move(): void {
    this.x -= this.speed;
    if (this.x < -this.xLimit) {
      this.x = this.xLimit;
      this.resetCloud();
    }
  }
}
